import React from 'react';
import { ErrorMessage, Field, FieldConfig } from 'formik';
import TextareaAutosize from 'react-textarea-autosize';

import {
    container,
    light,
    iconBox,
    icon,
    inputBox,
    input,
    hasIcon,
    labelBox,
} from './input.module.scss';

import Error from './error';

export interface IInputProps {
    className?: string;
    inputClassName?: string;
    name: string;
    label?: string;
    placeholder?: string;
    as?: FieldConfig['as'];
    rows?: number;
    identifier?: string | number;
    Icon?: React.SVGFactory;
    isLight?: boolean;
}

const Input: React.FC<IInputProps & Record<string, any>> = ({
    className = '',
    inputClassName = '',
    name,
    label = '',
    placeholder = '',
    as,
    rows = 3,
    identifier = '',
    Icon,
    isLight = false,
    ...rest
}) => {
    return (
        <div className={`${container} ${className} ${isLight ? light : ''}`}>
            {label ||
                (placeholder && (
                    <label className={labelBox} htmlFor={`${name}${identifier}`}>
                        {label || placeholder}
                    </label>
                ))}
            <div className={`${inputBox}`}>
                {Icon && (
                    <div className={iconBox}>
                        <Icon className={icon} />
                    </div>
                )}
                <Field
                    as={as === 'textarea' ? TextareaAutosize : ''}
                    {...(as === 'textarea' ? { minRows: rows } : {})}
                    id={`${name}${identifier}`}
                    name={name}
                    className={`${input} ${inputClassName} ${Icon ? hasIcon : ''}`}
                    placeholder={placeholder}
                    {...rest}
                />
            </div>
            <ErrorMessage name={name} component={Error} />
        </div>
    );
};

export default Input;
